const explanation_carousel = () => {

    $('.explanation_carousel--wrapper').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '',
        nextArrow: '.explanation_carousel--next',
        responsive: [
            {
              breakpoint: 991,
              settings: {
                prevArrow: '.explanation_carousel--prev',
              }
            },
        ]
    });

};

export default explanation_carousel;